'use client';

import { cn } from '@workspace/lib';
import { productSummaryVariants } from '@workspace/blocks/ProductSummary/productSummary.variants';
import { PRODUCT_SUMMARY_MEDIA_DIMENSIONS } from './product-summary-layout';
import { useProductSummary } from './useProductSummary';
import { ProductSummaryProps } from './product-summary.types';
import { ProductSummaryContent } from './ui/ProductSummaryContent';
import { ProductSummaryMedia } from './ui/ProductSummaryMedia';

export function ProductSummary({ block }: ProductSummaryProps) {
  const {
    isActive,
    resolvedHeading,
    backgroundClass,
    hasMedia,
    imageOrderClass,
    contentOrderClass,
    handleAskGregClick,
    getOpenInNewTab,
    description,
    ctaUnderHeadline,
    ctaUnderDescription,
    isVideo,
    video,
    image,
    headline,
    layoutStyle,
    cleanImagePosition,
  } = useProductSummary(block);

  const {
    container,
    wrapper,
    media,
    content,
    heading,
    description: descriptionSlot,
    hyperlink,
    hyperlinkIcon,
    video: videoClass,
    placeholder,
  } = productSummaryVariants({
    layoutStyle,
    imagePosition: cleanImagePosition === 'right' ? 'right' : 'left',
  });
  const mediaDimensions = PRODUCT_SUMMARY_MEDIA_DIMENSIONS[layoutStyle];

  if (isActive === false) return null;

  return (
    <div className={cn('product-summary-bg w-full', backgroundClass)}>
      <div className={cn('product-summary-container porta-container', container())}>
        <div
          className={cn(
            'product-summary-wrapper flex w-full flex-col items-center justify-center md:flex-row',
            wrapper(),
          )}
        >
          {/* Media */}
          <div
            className={cn(
              'image-container',
              imageOrderClass,
              'flex w-full items-center justify-center bg-transparent',
              media(),
            )}
          >
            {hasMedia ? (
              <ProductSummaryMedia
                isVideo={isVideo}
                video={video}
                image={image}
                headline={headline}
                dimensions={mediaDimensions}
                videoClassName={videoClass()}
                placeholderClassName={placeholder()}
              />
            ) : (
              <div
                className={cn(
                  'flex items-center justify-center bg-light-silver text-center text-secondary-400',
                  placeholder(),
                )}
              />
            )}
          </div>

          {/* Content */}
          <div className={cn('content-container flex w-full flex-col', contentOrderClass, content?.())}>
            <ProductSummaryContent
              resolvedHeadingText={resolvedHeading.resolvedHeadingText}
              headingFontClass={resolvedHeading.headingFontClass}
              description={description}
              ctaUnderHeadline={ctaUnderHeadline}
              ctaUnderDescription={ctaUnderDescription}
              onAskGregClick={handleAskGregClick}
              getOpenInNewTab={getOpenInNewTab}
              contentClassName="gap-xs md:gap-sm"
              headingClassName={heading?.()}
              descriptionClassName={descriptionSlot?.()}
              hyperlinkClassName={hyperlink?.()}
              hyperlinkIconClassName={hyperlinkIcon?.()}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
